module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "p02"
    }
  }, [_c('h1', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Wilc_9780312322496_epub_L02_r1.png"
    }
  }), _vm._v(" "), _c('em', [_vm._v("PART TWO")])]), _vm._v(" "), _c('h1', {
    staticClass: "subchapter"
  }, [_vm._v("WAR")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“You had to mature fast or die."), _c('br'), _vm._v("I just sort of clenched down and lost"), _c('br'), _vm._v("feelings and went at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("Butch Voris")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adc42ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312322496_epub_p02_r1.vue
// module id = 102
// module chunks = 0